import React, { useState } from "react";
import styles from "./Sidebar.module.scss";
import { Link, NavLink, useLocation } from "react-router-dom";

// img
import logo from "../../../Assets/images/logo.png";
import s1 from "../../../Assets/images/sg1.png";
import s2 from "../../../Assets/images/sg2.png";
import { Accordion, Button } from "react-bootstrap";
import { 
  My_CASELOAD,
  My_ACHIEVEMENTS
} from "config/paths";
import { useLogoutMutation } from "store/services/sso";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import useSocket from "utils/socket/socket";
import { store } from "store/store";
import { useSelector } from "react-redux";

const Sidebar = ({ sidebar, setSidebar }) => {

  const isVeteran = store.getState()?.auth?.user?.role_type === "veteran";
  const profile = useSelector((state) => state?.auth?.user)
  const assignedCategory = profile?.assigned_client_category
    ? profile.assigned_client_category.split(',').map(item => item.trim())
    : [];
  const location = useLocation();
  const pageActive = location.pathname;
  const socket = useSocket();

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logout, { isLoading: logoutLoading }] = useLogoutMutation();

  const handleLogout = async () => {
    try {

      setShowLogoutModal(false)
      await logout();
      socket.disconnect();
    } catch (err) {
      console.error("Error logging user out", err);
    }
  };

  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  const CustomBox = ({ children }) => {
    return (
      <div className="d-flex opacity-100 gap-2 px-3 align-items-center">
        {children}
      </div>
    );
  };

  return (
    <div
      className={`${styles.sidebar} ${sidebar && styles.active
        } sidebar sidebar-icon position-fixed shadow-lg  `}
    >
      <ConfirmationPop
        confirmation={showLogoutModal}
        setConfirmation={setShowLogoutModal}
        type={"logout"}
        confirmHandler={handleLogout}
      />

      {logoutLoading && <LoadingOverlay />}
      <Button
        onClick={handleSidebar}
        variant="transparent"
        className="position-absolute border-0 p-2 closeBtn d-lg-none"
        style={{ top: 0, right: 0, zIndex: 99 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="21"
          viewBox="0 0 15 21"
          fill="none"
        >
          <path
            d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
            fill="black"
          />
        </svg>
      </Button>
      <div
        className={`${styles.top} top text-center px-3  position-relative`}
      >
        <img
          src={s2}
          style={{ left: 0, bottom: 0 }}
          alt=""
          className="img-fluid position-absolute"
        />
        <img
          src={s1}
          style={{ right: 0, top: 0 }}
          alt=""
          className="img-fluid position-absolute"
        />
        <Link to="/" className={`${styles.logo} logo`}>
          <img src={logo} alt="" className="img-fluid" />
        </Link>
      </div>
      <Accordion style={{ height: "calc(100vh - 70px)" }}
        className={`${styles.linkWrpper} linkWrpper  px-2.5 bg-white overflow-x-hidden overflow-y-auto`}

        defaultActiveKey={["0", "1"]}
        alwaysOpen
      >
        <div className="">
          <ul className="list-unstyled ps-0 mb-0">    
            <li className="">
              <NavLink
                to={My_CASELOAD}
                className={`${styles.link} ${pageActive.includes(My_CASELOAD) &&
                  styles.active
                  } d-flex align-items-center gap-10 `}
              >
               My CaseLoad 

              </NavLink>
            </li> 
            <li className="">
              <NavLink
                to={My_ACHIEVEMENTS}
                className={`${styles.link} ${pageActive.includes(My_ACHIEVEMENTS) &&
                  styles.active
                  } d-flex align-items-center gap-10 `}
              >
               My Achievements

              </NavLink>
            </li> 
           
          </ul>
        </div>
      </Accordion>
    </div>
  );
};

export default Sidebar;
